<template>
    <div
        class="w-full mb-3 p-4 rounded-xl border border-theme-border bg-theme-card"
    >
        <div class="flex items-center justify-between mb-3">
            <div class="flex items-center gap-2">
                <span class="font-mono font-semibold text-theme-base">
                    {{ reference.barcode }}
                </span>
                <span
                    v-if="reference.isDefault"
                    class="text-xs font-semibold px-2 py-0.5 rounded-full bg-brand-blue text-white"
                >
                    Predeterminada
                </span>
            </div>
            <div v-if="deleteEnabled">
                <app-button danger icon @click="remove">🗑</app-button>
            </div>
        </div>

        <div
            v-if="reference.isDefault"
            class="mb-3 p-2 rounded-lg bg-theme-warning text-xs flex gap-1.5"
        >
            <span class="flex-shrink-0">⚠️</span>
            <span>
                Al guardar también se actualizará el precio del producto padre.
            </span>
        </div>

        <price-offer-fields
            v-model="prices"
            class="mt-8"
            :enabled="updateEnabled"
            :current-price="currentValue('currentPrice')"
            :current-price-offer="currentValue('currentPriceOffer')"
            :current-cost="currentValue('currentCost')"
            @blur="emitUpdate"
        />
    </div>
</template>

<script>
import PriceOfferFields from "@/components/utils/PriceOfferFields.vue";

export default {
    name: "ReferencePriceManage",
    components: { PriceOfferFields },
    props: {
        reference: {
            type: Object,
            required: true
        },
        updateEnabled: {
            type: Boolean,
            default: true
        },
        deleteEnabled: {
            type: Boolean,
            default: true
        }
    },
    emits: ["update", "remove"],
    data() {
        return {
            localPrice: this.reference.newPrice,
            localPriceOffer: this.reference.newPriceOffer,
            localCost: this.reference.newCost
        };
    },
    computed: {
        prices: {
            get() {
                return {
                    price: this.localPrice,
                    priceOffer: this.localPriceOffer,
                    cost: this.localCost
                };
            },
            set({ cost, price, priceOffer }) {
                this.localPrice = price;
                this.localPriceOffer = priceOffer;
                this.localCost = cost;
            }
        }
    },
    watch: {
        reference(value) {
            this.localPrice = value.newPrice;
            this.localPriceOffer = value.newPriceOffer;
            this.localCost = value.newCost;
        }
    },
    methods: {
        currentValue(key) {
            const value = this.reference[key];
            return value === undefined || value === null ? null : value;
        },
        emitUpdate() {
            this.$emit("update", {
                ...this.reference,
                newPrice: this.localPrice,
                newPriceOffer: this.localPriceOffer,
                newCost: this.localCost
            });
        },
        remove() {
            this.$emit("remove", { barcode: this.reference.barcode });
        }
    }
};
</script>
